import { Component, OnInit } from '@angular/core';
import { memberPerkService } from '../../Services/memberPerk.service';
import { AuthService } from '../../Services/auth.service';

@Component({
  selector: 'app-member-perks-list',
  template: require('./member-perks-list.component.html'),
  styles: [require('./member-perks-list.component.css')]
})
export class MemberPerksListComponent implements OnInit {
  
  // data = [
  //   { 
  //     sponsor: "Wolfs Performance", 
  //     content: `
  //             <base target="_blank">
  //             <h1>Wolfs Performance</h1>
  //             <p>
  //               Joris Verreydt is een Master in de Revalidatiewetenschappen en Kinesitherapie met specifieke expertise in sportrevalidatie en manuele therapie. Vanuit zijn ervaring als competitief wielrenner en kinesitherapeut heeft hij zich bij Bakala Academy ontwikkeld tot expert bikefitting. Nadien heeft hij Wolf Performance opgericht en momenteel is hij één van de toonaangevende personen voor bikefitting in België en in het buitenland. Hij heeft ervaring met profrenners van verschillende ploegen evenals vele recreatieve atleten.
  //             </p>
  //             <p>
  //             <a href="https://wolfperformance.be/">Wolfs performance website </a>
  //             </p>
  //             <img src="https://picsum.photos/400/400"><br>
  //             `
  //   },
  //   { 
  //     sponsor: "Lowie Verbinnen", 
  //     content: `
  //             <h1>Lowie Verbinnen</h1>
  //             <p>
  //             Lowie is ne fijne kerel
  //             </p>
              
  //             `
  //   },
  //   { 
  //     sponsor: "Joske Vermeulen", 
  //     content: `
  //             <h1>Joske Vermeulen</h1>
  //             <p>
  //              Hier kan ik wel wat mee... 

  //             </p>

  //             <ul>
  //               <li> item 1</li>
  //               <li> item 2</li>
  //               <li> item 3</li>
  //             </ul>
              
  //             `
  //   }
  // ];
  data : any[] = [];

  constructor(private memberPerkService: memberPerkService, private auth: AuthService) { }

  ngOnInit() {
    this.memberPerkService.getAllPerks().subscribe( res =>{
      if (res.status == 200){
        this.data = res.value 
      }
      
    })

  }



 
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/member-perks-list/member-perks-list.component.ts